export const beyondComplianceApis = [
    {
        type: "file",
        input: "apis/beyond-compliance/v1/crowdfunding.yaml",
        path: "/products/beyond-compliance/api-reference/crowdfunding"
    },
    {
        type: "file",
        input: "apis/beyond-compliance/v1/microlending.yaml",
        path: "/products/beyond-compliance/api-reference/microlending"
    },
    {
        type: "file",
        input: "apis/beyond-compliance/v1/payment-service.yaml",
        path: "/products/beyond-compliance/api-reference/payment-service"
    },
    {
        type: "file",
        input: "apis/beyond-compliance/v1/remittance.yaml",
        path: "/products/beyond-compliance/api-reference/remittance"
    },
    {
        type: "file",
        input: "apis/beyond-compliance/v1/transaction-reporting.yaml",
        path: "/products/beyond-compliance/api-reference/transaction-reporting"
    },
    {
        type: "file",
        input: "apis/beyond-compliance/virtual-assets/v1/custodial-wallet-provider.yaml",
        path: "/products/beyond-compliance/api-reference/virtual-assets/custodial-wallet-provider"
    },
    {
        type: "file",
        input: "apis/beyond-compliance/virtual-assets/v1/exchange.yaml",
        path: "/products/beyond-compliance/api-reference/virtual-assets/exchange"
    },
    {
        type: "file",
        input: "apis/beyond-compliance/virtual-assets/v1/issuer.yaml",
        path: "/products/beyond-compliance/api-reference/virtual-assets/issuer"
    },
    {
        type: "file",
        input: "apis/beyond-compliance/virtual-assets/v1/payment-service-provider.yaml",
        path: "/products/beyond-compliance/api-reference/virtual-assets/payment-service-provider"
    }
]